import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PagePaths } from '@/routes/page-paths';
import { CryptoAsset } from '@/shared/modules/wallet/use-crypto-assets';

export interface ReceivePageLocationState {
  returnTo: string;
  returnState: unknown;
  initialCoinType?: string;
  initialCoinSymbol: string;
}

interface UseOpenReceiveOptions {
  isMobile: boolean;
  onOpenModal: () => void;
}

export const useOpenReceive = ({ isMobile, onOpenModal }: UseOpenReceiveOptions) => {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (coin?: Pick<CryptoAsset, 'coinType' | 'symbol'>) => {
      if (!isMobile) {
        onOpenModal();
        return;
      }

      const state: ReceivePageLocationState = {
        returnTo: `${location.pathname}${location.search}`,
        returnState: location.state ?? null,
        ...(coin?.coinType ? { initialCoinType: coin.coinType } : {}),
        initialCoinSymbol: coin?.symbol ?? 'SUI',
      };

      navigate(PagePaths.portfolioReceive, { state });
    },
    [isMobile, location.pathname, location.search, location.state, navigate, onOpenModal],
  );
};
